import React from 'react';
import './LegalPage.css';

const ClausulasConsentimiento = () => (
    <div className="legal-page">
        <h1>Cláusulas de consentimiento para formularios</h1>

        <h2>1. Formulario de contacto o suscripción</h2>
        <p>Al completar el formulario de contacto, suscripción o cualquier otro similar en este sitio web, el usuario consiente de forma expresa el tratamiento de sus datos personales por parte de Navi con la finalidad de responder a su solicitud, ofrecerle información relacionada con los servicios, y/o mantener comunicaciones comerciales personalizadas.</p>

        <h2>2. Finalidad del tratamiento</h2>
        <ul>
            <li>Atender las consultas planteadas</li>
            <li>Proveer los servicios solicitados</li>
            <li>Enviar información comercial sobre novedades, servicios y contenidos relacionados con Navi</li>
        </ul>

        <h2>3. Conservación de los datos</h2>
        <p>Los datos personales se conservarán durante el tiempo necesario para cumplir con la finalidad para la que fueron recabados o mientras el usuario no solicite su supresión.</p>

        <h2>4. Derechos del usuario</h2>
        <p>El usuario puede ejercer los derechos de acceso, rectificación, supresión, limitación y oposición mediante correo a contacto@navitechlabs.com junto con copia de su documento de identidad.</p>

        <h2>5. Consentimiento informado</h2>
        <p>Al marcar la casilla correspondiente en los formularios del sitio web, el usuario declara haber leído y aceptado la Política de Privacidad y estas cláusulas, autorizando el tratamiento en los términos indicados.</p>

        <h2>6. Cesión a terceros</h2>
        <p>Navi no cederá los datos personales del usuario a terceros sin su consentimiento, salvo obligación legal o necesidad operativa por encargo de tratamiento regulado mediante contrato legal conforme al RGPD.</p>
    </div>
);

export default ClausulasConsentimiento;
